import { TweenMax, TweenLite } from 'gsap';
global.TweenMax = TweenMax;
global.TweenLite = TweenLite;

global.$ = global.jQuery = require('jquery');
require('./utils/jqExtensions');
require('slick-carousel');
import Masonry from 'masonry-layout';
global.Masonry = Masonry;
require('gsap/ScrollToPlugin');
import ClipboardJS from 'clipboard';
global.ClipboardJS = ClipboardJS;

global.Front = new (function Front() {
	// eslint-disable-line
	this.env = require('./utils/ENV');
	this.dom = require('./utils/DOM');
	this.utils = require('./utils/Utils');

	this.classes = {
		Callback: require('./classes/Callback'),
	};

	this.helpers = {};
	this.modules = {
		CopyLink: require('./modules/CopyLink'),
		HideOnScrolls: require('./modules/HideOnScrolls'),
		IssuePage: require('./modules/IssuePage'),
		MagazinePage: require('./modules/MagazinePage'),
		MainPage: require('./modules/MainPage'),
		Menu: require('./modules/Menu'),
		NextArticle: require('./modules/NextArticle'),
		Subscription: require('./modules/Subscription'),
		Sharing: require('./modules/Sharing'),
		SlickSliders: require('./modules/SlickSliders'),
	};

	// Startup
	$(() => {
		// Remove _loading modificator
		this.dom.$html.removeClass('_loading');
		// fix for ie
		if (this.env.isIE) {
			this.dom.$body.html(`<section class="page-ie">
				<div class="container">
					<div class="page-ie__container">
						<h1 class="page-ie__title">Поставьте последнюю поддерживаемую версию Google Chrome или Firefox</h1>
						<a href="https://www.google.ru/chrome/browser/desktop/" target="_blank" class="page-ie__btn default-btn">Google Chrome</a>
						<a href="https://www.mozilla.org/ru/firefox/new/" target="_blank" class="page-ie__btn default-btn">Firefox</a>
					</div>
				</div>
			</section>`);
		}
	});
})();

if (module.hot) {
	module.hot.accept();
}
